export default "__VITE_ASSET__C1wuRH$t__"